module.exports = __webpack_public_path__ + "img/QRL.32ad2ed9.svg";